import React from 'react';
import styled from 'styled-components';

import BestFlag from '../../components/UI/BestFlag';
import { useNavigate } from 'react-router-dom';

const Wrapper = styled.div`
	width: 250px;
	height: 450px;
	display: flex;
	flex-direction: column;
	gap: 15px;

	box-sizing: border-box;
`;

const ImageWrapper = styled.div`
	width: 250px;
	height: 350px;
`;

const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 8px;
`;

const Text = styled.p`
	margin: 0;
	padding: 0;
	font: normal 380 20px Pretendard Variable;
`;

export default function ItemWrapper(props) {
	const data = props.product;

	const navigate = useNavigate();

	const onClickMenu = () => {
		navigate(`/products/detail/${data.productCode}`);
	};

  	return (
		<Wrapper onClick={onClickMenu} style={{ cursor: 'pointer' }}>
			<ImageWrapper>
				<img src={data.productThumbnail} alt={data.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
			</ImageWrapper>
			<TextWrapper>
				<Text>{data.name}</Text>
				<Text><strong>{data.price.toLocaleString()} 원</strong></Text>
				{
					data.bestProduct ? <BestFlag size="small" /> : null
				}
			</TextWrapper>
		</Wrapper>
  	);
}